import React from 'react';
import AuthProvider from './context/auth';
import RoutesComponent from '../src/routes/RoutesComponent';

function App() {
  return (
    <AuthProvider>
      <RoutesComponent />
    </AuthProvider>
  );
}

export default App;
